import { useHistory } from "react-router-dom";
import { PS_URLS, useCompanyId } from "../../core";
import { ICP4OnboardingWorkflowContainer } from "../icp4/ICP4OnboardingWorkflowContainer";

export function ICP4InterestRegistered() {
  const companyId = useCompanyId();
  const history = useHistory();
  return (
    <ICP4OnboardingWorkflowContainer heading="Thank you for submitting your information." 
    subHeading="Our team will verify the data and activate your account. Once completed, within the next 24-48 hours we'll be in touch with you to access your account."
  backButtonProps={{
    onClick: () => {
      history.push(`${PS_URLS(companyId).icp4ProjectsConfiguration()}`);
    }
  }}
  ><></>
    </ICP4OnboardingWorkflowContainer>
  );
}